<template>
  <v-dialog scrollable v-model="config.status.active" max-width="800px">
    <v-card class="dialog">
      <v-card-title class="primary pa-0">
        <v-toolbar flat v-if="config.status.importing" class="blue darken-2 white--text">
          <v-toolbar-title class="headline">ライブラリ</v-toolbar-title>
        </v-toolbar>
        <v-toolbar flat v-else class="amber blue-grey--text text--darken-4">
          <v-toolbar-title class="headline">申込書送付</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="form.valid" lazy-validation>
            <v-row dense>
              <v-col cols="12">
                <v-radio-group row
                  v-model="form.online"
                  :readonly="!isAuthed"
                >
                  <v-radio label="オンライン未完" color="blue darken-2" value=""></v-radio>
                  <v-radio label="オンライン完了" color="blue darken-2" value="done"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12">
                <v-menu lazy offset-y full-width
                  v-if="isAuthed"
                  v-model="config.datepickers.date"
                  transition="scale-transition"
                  min-width="290px"
                  :close-on-content-click="false"
                  :nudge-right="40"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field readonly
                      v-model="printFormDate"
                      label="完了日付"
                      v-on="on"
                      :append-icon="form.date ? 'fal fa-times' : null"
                      @click:append="form.date = ''"
                    />
                  </template>
                  <v-date-picker
                    v-model="form.date"
                    locale="ja"
                    color="amber"
                    :day-format="date => new Date(date).getUTCDate()"
                    @input="config.datepickers.date = false"
                  />
                </v-menu>
              </v-col>
              <v-col cols="12">
                <ClientFiler v-if="form.mid" ref="filer"
                  :rid="form.mid"
                  :cid="getClientId"
                  :authed="getArrangerId"
                  :fixedRoot="true"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="secondary" @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed v-if="isAuthed" color="secondary" @click.stop="submit" :loading="isLoading">保存する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ClientFiler from '@/components/filers/client'
export default {
  name: 'authorProgsModalsPost',
  components: {
    ClientFiler
  },
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          importing: false
        },
        datepickers: {
          date: false
        }
      },
      form: {
        valid: true,
        id: '',
        cid: '',
        clientId: '',
        date: '',
        online: '',
        mid: '',
        import: false
      },
      store: {
        lib: {},
        imports: []
      },
      rules: {
        date: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'progs/update/item/meta', {
            id: this.form.id,
            cid: this.form.cid,
            type: 'post',
            form: {
              content: this.form.date,
              option: {
                online: this.form.online
              }
            }
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('done', {
                id: this.form.cid,
                type: 'post',
                value: {
                  date: this.form.date,
                  online: this.form.online
                }
              })
              this.close()
            }
            this.$set(this.config.status, 'loading', false)
          }).catch(err => {
            console.log(err)
            this.$set(this.config.status, 'loading', false)
          })
        })
      }
    },
    open: function (val) {
      const { id, aid, cid, clientId, authed, date, online, mid } = val
      this.$set(this.config.status, 'active', true)
      this.$set(this, 'form', {
        valid: true,
        id: id,
        aid: aid,
        cid: cid,
        clientId: clientId,
        authed: authed,
        date: date,
        online: online,
        mid: mid,
        import: false
      })
      this.$nextTick(() => {
        this.$refs.filer.init()
      })
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    }
  },
  computed: {
    isActive () {
      return this.config.status.active
    },
    isLoading () {
      return this.config.status.loading
    },
    isAuthed () {
      return this.form.authed
    },
    getClientId () {
      return this.form.clientId
    },
    getArrangerId () {
      return this.form.aid
    },
    printFormDate () {
      return (this.form.date) ? this.$moment(this.form.date).format('YYYY/MM/DD') : ''
    }
  }
}
</script>
